import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IOrganization, IPage } from 'common/src/types/interfaces';
import {
  ICreateEnergyStarAccountDto,
  ICreateOrganizationWithInitialUsersDto,
  IUpdateOrganizationDto,
} from 'common/src/types/organization.dtos';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getOrganizations = async (
  params?: DataQueryParams,
): Promise<IPage<IOrganization>> =>
  await getRequest(API_BASE_PATHS.ORGANIZATIONS, formatQueryParams(params));

export const getOrganization = async (id: string): Promise<IOrganization> =>
  await getRequest(`${API_BASE_PATHS.ORGANIZATIONS}/${id}`);

export const addOrganization = async (
  body: ICreateOrganizationWithInitialUsersDto,
): Promise<string> => await postRequest(API_BASE_PATHS.ORGANIZATIONS, {}, body);

export const updateOrganization = async (
  id: string,
  body: IUpdateOrganizationDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.ORGANIZATIONS}/${id}`, {}, body);

export const createEnergyStarAccount = async (
  id: string,
  body: ICreateEnergyStarAccountDto,
): Promise<void> =>
  await postRequest(
    `${API_BASE_PATHS.ORGANIZATIONS}/${id}/create-energy-star-account`,
    {},
    body,
  );
